import { NavigableButton } from '@carvana/ds-button';
import Link from '@carvana/ds-link';
import cx from 'classnames';
import { Phone } from 'lucide-react';
import ShiftDigitalEventName from '~/constants/dealership/ShiftDigitalEventName';
import useServicePhone from '~/hooks/dealership/selectors/useServicePhone';
import styles from './BottomCTA.module.css';

export default function BottomCTA() {
  const servicePhone = useServicePhone();

  return (
    <section className="relative overflow-hidden bg-background-primary px-lg py-4xl md:px-2xl md:py-[80px]">
      <div className="relative mx-auto max-w-[900px] text-center">
        <div className="mb-xl text-[#A5D8FF] t-label-xs tracking-widest">
          READY WHEN YOU ARE
        </div>

        <h2 className={cx('mb-xl text-text-inverse', styles.heading)}>
          Service you can
          <br />
          actually trust.
        </h2>

        <p className="mx-auto mb-3xl max-w-[560px] text-[#D2EBFF] t-body-lg">
          Book your appointment in under two minutes.
        </p>

        <div className="flex flex-col items-center gap-lg sm:flex-row sm:flex-wrap sm:justify-center">
          <NavigableButton
            variant="primaryInverted"
            size="md"
            href="/schedule"
            data-adobe-id="schedule-service-bottom"
            data-analytics-id="Service Bottom CTA - Schedule Service"
            data-sda-event={ShiftDigitalEventName.ScheduleServiceClick}
            data-testid="schedule-service-bottom"
          >
            Schedule service now
          </NavigableButton>

          {servicePhone && (
            <Link
              href={`tel:${servicePhone.number}`}
              priority="inverse"
              size="sm"
              preventVisitedColor
              className="inline-flex items-center gap-x-sm"
              data-adobe-id="click-to-call-service-bottom"
              data-analytics-id="Service Bottom CTA - Phone"
              data-sda-event={ShiftDigitalEventName.ClickToCall}
              data-sda-event-set-prop={`clickToCallDepartment|${servicePhone.label}`}
              data-testid="service-bottom-phone"
            >
              <Phone className="size-[18px]" />
              Call {servicePhone.number}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
